var _circle, _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClarity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_87)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 35.2564C28 32.3534 30.41 30 33.3828 30H51.2536C54.2264 30 56.6364 32.3534 56.6364 35.2564V59.6462C56.6364 62.5492 54.2264 64.9026 51.2536 64.9026H33.3828C30.41 64.9026 28 62.5492 28 59.6462V35.2564Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_87)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6086 62.9147C72.2022 57.0499 71.7525 48.6262 66.2598 43.2624C60.2773 37.4203 50.5778 37.4203 44.5953 43.2624C38.6128 49.1044 38.6128 58.5763 44.5953 64.4183C50.088 69.7821 58.7142 70.2212 64.72 65.7355L69.35 70.2568C69.7704 70.6673 70.452 70.6673 70.8725 70.2568L72.2386 68.9227C72.659 68.5122 72.659 67.8465 72.2386 67.436L67.6086 62.9147Z",
    fill: "url(#paint1_linear_1062_87)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6086 62.9147C72.2022 57.0499 71.7525 48.6262 66.2598 43.2624C60.2773 37.4203 50.5778 37.4203 44.5953 43.2624C38.6128 49.1044 38.6128 58.5763 44.5953 64.4183C50.088 69.7821 58.7142 70.2212 64.72 65.7355L69.35 70.2568C69.7704 70.6673 70.452 70.6673 70.8725 70.2568L72.2386 68.9227C72.659 68.5122 72.659 67.8465 72.2386 67.436L67.6086 62.9147Z",
    stroke: "url(#paint2_linear_1062_87)",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1062_87)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4658 62.924L67.5231 62.8508C72.0843 57.0274 71.6378 48.6628 66.1836 43.3367C60.2432 37.5357 50.6118 37.5357 44.6714 43.3367C38.7309 49.1377 38.7309 58.543 44.6714 64.344C50.1255 69.67 58.6911 70.1061 64.6546 65.652L64.7295 65.5961L69.4261 70.1824C69.8045 70.5519 70.418 70.5519 70.7963 70.1824L72.1625 68.8484C72.5408 68.4789 72.5408 67.8798 72.1625 67.5103L67.4658 62.924ZM64.72 65.7355C58.7142 70.2212 50.088 69.7821 44.5953 64.4183C38.6128 58.5763 38.6128 49.1044 44.5953 43.2624C50.5778 37.4203 60.2773 37.4203 66.2598 43.2624C71.7525 48.6262 72.2022 57.0499 67.6086 62.9147L72.2386 67.436C72.659 67.8465 72.659 68.5122 72.2386 68.9227L70.8725 70.2568C70.452 70.6673 69.7704 70.6673 69.35 70.2568L64.72 65.7355Z",
    fill: "url(#paint3_linear_1062_87)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4658 62.924L67.5231 62.8508C72.0843 57.0274 71.6378 48.6628 66.1836 43.3367C60.2432 37.5357 50.6118 37.5357 44.6714 43.3367C38.7309 49.1377 38.7309 58.543 44.6714 64.344C50.1255 69.67 58.6911 70.1061 64.6546 65.652L64.7295 65.5961L69.4261 70.1824C69.8045 70.5519 70.418 70.5519 70.7963 70.1824L72.1625 68.8484C72.5408 68.4789 72.5408 67.8798 72.1625 67.5103L67.4658 62.924ZM64.72 65.7355C58.7142 70.2212 50.088 69.7821 44.5953 64.4183C38.6128 58.5763 38.6128 49.1044 44.5953 43.2624C50.5778 37.4203 60.2773 37.4203 66.2598 43.2624C71.7525 48.6262 72.2022 57.0499 67.6086 62.9147L72.2386 67.436C72.659 67.8465 72.659 68.5122 72.2386 68.9227L70.8725 70.2568C70.452 70.6673 69.7704 70.6673 69.35 70.2568L64.72 65.7355Z",
    fill: "url(#paint4_radial_1062_87)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_87",
    x: 37.9584,
    y: 36.7309,
    width: 36.7453,
    height: 35.9836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_87"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_87",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1062_87",
    x: 10.1084,
    y: 8.88086,
    width: 92.4453,
    height: 91.6836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_87"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_87",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_87",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_87",
    x1: 43.5804,
    y1: 41.8041,
    x2: 78.2445,
    y2: 60.1842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_87",
    x1: 59.0349,
    y1: 44.1615,
    x2: 70.7216,
    y2: 72.0859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1062_87",
    x1: 44.7777,
    y1: 37.7493,
    x2: 74.8183,
    y2: 55.7106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1062_87",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9573 69.5274) rotate(-50.3099) scale(25.121 41.2672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarity);
export default __webpack_public_path__ + "static/media/clarity.b5d01202d278cca76192cbd355217aa2.svg";
export { ForwardRef as ReactComponent };